const getZipcodeValidationStatus = async (zipcode) => {
  try {
    const response = await fetch(
      `/api/zipcodeChecker?zipcode=${encodeURIComponent(zipcode)}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.ok) {
      console.error(`${response}`);
      return {
        success: false,
        message: 'Failed to fetch data from Google Maps',
        status: response.status
      };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching Google Maps data:', error);
    return {
      success: false,
      message: error.message,
      data: error.data
    };
  }
};

export { getZipcodeValidationStatus };
